import { useState, useEffect, useCallback } from 'react';
import { getTheme } from '../themes';

export function useThemePlayer(themeId) {
  const theme = getTheme(themeId);
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const currentScreen = theme?.screens[currentIndex];
  
  const nextScreen = useCallback(() => {
    if (theme && currentIndex < theme.screens.length - 1) {
      setCurrentIndex(prev => prev + 1);
    }
  }, [currentIndex, theme]);
  
  const prevScreen = () => {
    if (currentIndex > 0) {
      setCurrentIndex(prev => prev - 1);
    }
  };
  
  const goToScreen = (index) => {
    if (theme && index >= 0 && index < theme.screens.length) {
      setCurrentIndex(index);
    }
  };

  useEffect(() => {
    if (!theme || !currentScreen) return;
    
    if (currentScreen.autoAdvance) {
      const timer = setTimeout(() => {
        nextScreen();
      }, currentScreen.delay || 5000);
      
      return () => clearTimeout(timer);
    }
  }, [currentIndex, currentScreen, nextScreen, theme]);
  
  if (!theme) {
    return {
      theme: null,
      currentScreen: null,
      screenNumber: 0,
      totalScreens: 0,
      progress: 0,
      nextScreen: () => {},
      prevScreen: () => {},
      goToScreen: () => {},
      canGoNext: false,
      canGoPrev: false,
    };
  }

  const startAgain = () => {
    setCurrentIndex(0);
  };
  
  return {
    theme,
    currentScreen,
    screenNumber: currentIndex + 1,
    totalScreens: theme.screens.length,
    progress: ((currentIndex + 1) / theme.screens.length) * 100,
    nextScreen,
    prevScreen,
    goToScreen,
    startAgain,
    canGoNext: currentIndex < theme.screens.length - 1,
    canGoPrev: currentIndex > 0,
  };
}
